import React, { useState } from 'react'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import gql from 'graphql-tag'

import { useQuery } from 'components/graphql'
import getNameOfGqlQuery from 'helpers/getNameOfGqlQuery'
import { listClientMessage as messageList, getClientMessage } from './gql'
import { StyledColList, ItemView } from 'components/SectionHandler'
import SideList from './components/SideListWrapper'
import formatDate from 'helpers/dateTimeFormatter'

import { StyledRow } from './styled'

const query = gql`query{_}`

const MessageSection = (props) => {
	const { recordId, getRouteById, history, sectionData, section, listQueryRef: { current } } = props
	const messageData = current?.data?.cashAssist?.listClientMessage
	let isRecordIdMatches = messageData?.items.some(i => i.id === recordId)
	if(!messageData) {
		isRecordIdMatches = true
	}
	const baseFilter = {}
	const interval = {
		from: moment(new Date()).utc().startOf('day').toISOString(),
		to: moment(new Date()).utc().endOf('day').toISOString()
	}
	const [rowData, setRowData] = useState({})
	const [dateInterval, setDateInterval] = useState(interval)
	const [showFilter, setShowFilter] = useState(false)
	const [filterValues, setFilterValues] = useState(baseFilter)
	const [isFiltered, setIsFiltered] = useState(baseFilter && Object.keys(baseFilter).length)
	const { data: messageListData, refetch } = useQuery(messageList, { skip: isEmpty(filterValues) || !recordId })

	const setFilter = newFilterValues => {
		setIsFiltered(!isEqual(newFilterValues, baseFilter))
		setFilterValues(newFilterValues)
		setShowFilter(false)
		setDateInterval(interval)
		history.replace({ pathname: `/${section}` })
	}

	const toggleFilterWindow = () => {
		setShowFilter(prevState => !prevState)
	}

	const clearFilter = () => {
		setIsFiltered(false)
		setFilterValues(baseFilter)
		setShowFilter(false)
		setDateInterval(interval)
		history.replace({ pathname: `/${section}` })
	}

	const handleCompleted = ({ cashAssist: { listClientMessage } }) => {
		let redirectPath = ''
		const sortedData = [...listClientMessage?.items || []].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
		const isAllMessageTable = sortedData.some(i => i.id === recordId)
		const firstMessage = sortedData[0]
		if(!recordId || !isAllMessageTable) {
			try {
				redirectPath = getRouteById(firstMessage?.id)
				if(redirectPath) {
					history.push({ pathname: redirectPath })
				}
			} catch (e) {
				// throw Error(e)
			}
		}
	}

	const handleChangeDateInterval = () => {
		refetch({ filter: { recipientId: rowData?.rowId, isForShop: filterValues?.isForShop, createdAt: { from: dateInterval.from, to: dateInterval.to } } })
	}

	const getRowData = (rowId, name) => {
		setRowData({ ...rowData, name, rowId })
		refetch(
			{ filter:
					{
						recipientId: rowId,
						isForShop: filterValues?.isForShop,
						createdAt: { from: dateInterval.from, to: dateInterval.to }
					}
			}
		)
	}

	return(
		<>
			<StyledRow>
				<StyledColList xs width='470px'>
					<SideList
						{...props}
						xs={0}
						onCompleted={handleCompleted}
						getRowData={getRowData}
						setFilter={setFilter}
						toggleFilterWindow={toggleFilterWindow}
						clearFilter={clearFilter}
						showFilter={showFilter}
						isFiltered={isFiltered}
						filterValues={filterValues}
					/>
				</StyledColList>
				<ItemView
					{...props}
					skipQuery={!isEmpty(filterValues) || !isRecordIdMatches}
					sectionData={{
						...sectionData,
						itemQuery: isEmpty(filterValues) ? getClientMessage : query
					}}
					subsectionProps={{
						filterValues: filterValues,
						messageListData: messageListData[getNameOfGqlQuery(messageList)]?.items,
						dateInterval: dateInterval,
						setDateInterval: setDateInterval,
						onClick: handleChangeDateInterval
					}}
					navBarProps={{
						getLabel: data => `${formatDate(data.createdAt, 'DD.MM.YYYY HH:mm')} (${data.subject || rowData?.name})`
					}}
				/>
			</StyledRow>
		</>
	)
}

export default MessageSection
